"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class GetProfileRequest extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'customer_id' }),
    (0, base_models_1.Docs)({
        example: '0172198189',
        description: 'ID of the customer. Either this or the delivery_address_key must be provided.',
    }),
    tslib_1.__metadata("design:type", String)
], GetProfileRequest.prototype, "customerId", void 0);
tslib_1.__decorate([
    (0, base_models_1.IsAddressKey)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'delivery_address_key' }),
    (0, base_models_1.Docs)({
        example: '1234AB_56_C',
        description: 'Delivery address of the customer. Either this or the customer_id must be provided.',
    }),
    tslib_1.__metadata("design:type", String)
], GetProfileRequest.prototype, "deliveryAddressKey", void 0);
exports.default = GetProfileRequest;
